import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { activityAPI } from '@/lib/api';

const HEARTBEAT_MS = 90 * 1000; // 90 s

/**
 * Envoie un heartbeat de présence pendant que l'onglet est visible.
 * Contexte "vnx" sur Inside VNX / fil, sinon "crm".
 * Alimente l'Impact Score (sessions, régularité, durée Inside VNX).
 */
export function useActivityTracker() {
    const location = useLocation();
    const pathRef = useRef(location.pathname);
    pathRef.current = location.pathname;

    useEffect(() => {
        const ctx = () => {
            const p = pathRef.current || '';
            return (p.includes('inside-vnx') || p.includes('/feed')) ? 'vnx' : 'crm';
        };
        const ping = () => {
            if (document.visibilityState === 'visible') {
                activityAPI.heartbeat(ctx()).catch(() => {});
            }
        };
        ping(); // ping initial
        const interval = setInterval(ping, HEARTBEAT_MS);
        const onVisible = () => { if (document.visibilityState === 'visible') ping(); };
        document.addEventListener('visibilitychange', onVisible);
        return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', onVisible);
        };
    }, []);
}
